<script>
export default {
  computed: {
    partyAffiliations: {
      get () {
        return this.$store.state.databaseSearch.partyAffiliations;
      },
      set (value) {
        this.$store.commit('databaseSearch/setPartyAffiliations', value);
      }
    },
    genders: {
      get () {
        return this.$store.state.databaseSearch.genders;
      },
      set (value) {
        this.$store.commit('databaseSearch/setGenders', value);
      }
    },
    races: {
      get () {
        return this.$store.state.databaseSearch.races;
      },
      set (value) {
        this.$store.commit('databaseSearch/setRaces', value);
      }
    }
  },

  mounted () {
    const self = this;
    self.races = self.paramToArray(self.$route.query.races);
    self.genders = self.paramToArray(self.$route.query.genders);
    self.partyAffiliations = self.paramToArray(self.$route.query.partyAffiliations);
  },

  destroyed () {
    const self = this;
    self.$store.commit('databaseSearch/clearPersonFacets');
  },

  methods: {
    paramToArray (param) {
      if (!!param) {
        return Array.isArray(param) ? param : [param];
      }
      else {
        return []
      }
    }
  }
}
</script>

<template lang="html">
  <div class="DatabaseSearch-facets u-mt3">

    <fieldset class="DatabaseSearch-facets-col1 u-mb2">
      <legend>Party Affiliation</legend>

      <div class="u-mb1">
        <input id="party-democrat" type="checkbox" value="32" v-model="partyAffiliations">
        <label for="party-democrat">Democrat</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input id="party-republican" type="checkbox" value="16" v-model="partyAffiliations">
        <label for="party-republican">Republican</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input id="party-other" type="checkbox" value="0" v-model="partyAffiliations">
        <label for="party-other">Other</label>
      </div>
    </fieldset>

    <fieldset class="DatabaseSearch-facets-col1 u-mb2">
      <legend>Gender</legend>

      <div class="u-mb1">
        <input type="checkbox" id="gender-male" value="m" v-model="genders">
        <label for="gender-male">Male</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input type="checkbox" id="gender-female" value="f" v-model="genders">
        <label for="gender-female">Female</label>
      </div>
    </fieldset>

    <fieldset class="DatabaseSearch-facets-col1 u-mb2">
      <legend>Race</legend>

      <div class="u-mb1">
        <input id="race-asian" type="checkbox" value="a" v-model="races">
        <label for="race-asian">Asian</label>
      </div>

      <div class="u-mb1">
        <input id="race-native" type="checkbox" value="aian" v-model="races">
        <label for="race-native">Native</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input id="race-black" type="checkbox" value="aa" v-model="races">
        <label for="race-black">Black</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input id="race-latino" type="checkbox" value="h" v-model="races">
        <label for="race-latino">Latino</label>
      </div>

      <div class="u-mt1 u-mb1">
        <input id="race-white" type="checkbox" value="c" v-model="races">
        <label for="race-white">White</label>
      </div>
    </fieldset>

  </div>
</template>



// WEBPACK FOOTER //
// person-facets.vue?33b4d438